import { useState } from 'react'
import styles from './ProductFeatures.module.css'
import clsx from 'clsx'
import { BasicStyledComponent, DSProductFeatureProps } from 'shared-definitions/types'
import ProductFeature from 'shared-components/ui/ProductFeature'
import AccordionElement from 'shared-components/layout/Accordion'
import ArrowBottomBird from 'shared-svg/ArrowBottomBird.svg'

interface ProductFeaturesProps extends BasicStyledComponent {
  vars: DSProductFeatureProps[]
}

const ProductFeatures: React.VFC<ProductFeaturesProps> = ({ className, vars }) => {
  const [expanded, setExpanded] = useState(false)

  if (!vars.length) {
    return null
  }

  const featured = vars.filter(f => f.featured)
  const secondary = vars.filter(f => !f.featured)

  // No featured flags (WP fallback) — flat layout like before
  if (featured.length === 0) {
    return (
      <div className={clsx(styles.container, className)}>
        {vars.map((item, index) => (
          <ProductFeature feature={item} key={index} />
        ))}
      </div>
    )
  }

  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.heroRow}>
        {featured.map((item, index) => (
          <div key={index} className={styles.heroItem}>
            <ProductFeature feature={item} variant="hero" />
          </div>
        ))}
      </div>

      {secondary.length > 0 && (
        <>
          <AccordionElement open={expanded}>
            <div className={styles.secondaryList}>
              {secondary.map((item, index) => (
                <ProductFeature feature={item} key={index} variant="compact" />
              ))}
            </div>
          </AccordionElement>
          <button
            type="button"
            className={styles.expandButton}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? 'Hide specs' : `Show all specs (${vars.length})`}
            <ArrowBottomBird
              className={clsx(styles.expandIcon, { [styles.expandIconOpen]: expanded })}
            />
          </button>
        </>
      )}
    </div>
  )
}

export default ProductFeatures
